import eventResult from 'src/components/forms/schemas/eventResult';
import patient from 'src/components/forms/schemas/patient';

export default {
  eventResult,
  patient,
};
